import React from 'react';
import { useTutorialContext } from '../../contexts/TutorialContext';
import AlarmDemoModal from './AlarmDemoModal';

const GlobalDemoModal = () => {
  const { showDemoModal, setShowDemoModal } = useTutorialContext();

  return (
    <AlarmDemoModal
      open={showDemoModal}
      onClose={() => setShowDemoModal(false)}
    />
  );
};

export default GlobalDemoModal;
